import { IGV, ICBPER } from '../../../Global';
import dr from '../../../Global';

const CODIGOS_AFECTACION = {
    GRAVADO: ['10', '11', '12', '13', '14', '15', '16', '17'],
    EXONERADO: ['20', '21'],
    INAFECTO: ['30', '31', '32', '33', '34', '35', '36', '37'],
    EXPORTACION: ['40'],
    GRATUITO: ['11', '12', '13', '14', '15', '16', '21', '31', '32', '33', '34', '35', '36', '37']
};

export const esOperacionGravada = (codigo) => CODIGOS_AFECTACION.GRAVADO.includes(codigo);
export const esOperacionExonerada = (codigo) => CODIGOS_AFECTACION.EXONERADO.includes(codigo);
export const esOperacionInafecta = (codigo) => CODIGOS_AFECTACION.INAFECTO.includes(codigo);
export const esOperacionExportacion = (codigo) => CODIGOS_AFECTACION.EXPORTACION.includes(codigo);
export const esOperacionGratuita = (codigo) => CODIGOS_AFECTACION.GRATUITO.includes(codigo);

export function calculateTotals(items, descuentoGlobalConImpuestos = 0) {
    let acumuladorGravado = 0;
    let acumuladorExonerado = 0;
    let acumuladorInafecto = 0;
    let acumuladorExportacion = 0;
    let acumuladorGratuito = 0;
    let acumuladorIcbperEnCentimos = 0;

    items.forEach(item => {
        const cantidadItem = parseFloat(item.cantidad || 0);
        const precioVentaConImpuestos = parseFloat(item.pVenta || 0);
        const descuentoItemConImpuestos = parseFloat(item.descuento || 0);
        const codigoIgvItem = String(item.igv);

        let tasaIgvAplicable = 0;
        if (esOperacionGravada(codigoIgvItem)) tasaIgvAplicable = IGV;

        const precioUnitarioSinImpuesto = dr(precioVentaConImpuestos / (1 + tasaIgvAplicable));
        
        const descuentoUnitarioSinImpuesto = dr(descuentoItemConImpuestos / (1 + tasaIgvAplicable));

        const valorVentaItem = (precioUnitarioSinImpuesto * cantidadItem) - descuentoUnitarioSinImpuesto;

        if (esOperacionGratuita(codigoIgvItem)) {
            acumuladorGratuito += valorVentaItem;
        } else {
            if (esOperacionGravada(codigoIgvItem)) {
                acumuladorGravado += valorVentaItem;
            } else if (esOperacionExonerada(codigoIgvItem)) {
                acumuladorExonerado += valorVentaItem;
            } else if (esOperacionInafecta(codigoIgvItem)) {
                acumuladorInafecto += valorVentaItem;
            } else if (esOperacionExportacion(codigoIgvItem)) {
                acumuladorExportacion += valorVentaItem;
            }
        }

        if (item.has_icbper) {
            acumuladorIcbperEnCentimos += Math.round(cantidadItem * ICBPER * 100);
        }
    });

    const descuentoGlobalNumerico = parseFloat(descuentoGlobalConImpuestos || 0);
    const montoDescuentoGlobalSinImpuesto = dr(descuentoGlobalNumerico / (1 + IGV));
    
    const totalGravadoNeto = acumuladorGravado - montoDescuentoGlobalSinImpuesto;
    
    const montoIgv = totalGravadoNeto * IGV;

    const totalGravadoCentimos = Math.round(totalGravadoNeto * 100);
    const totalExoneradoCentimos = Math.round(acumuladorExonerado * 100);
    const totalInafectoCentimos = Math.round(acumuladorInafecto * 100);
    const totalExportacionCentimos = Math.round(acumuladorExportacion * 100);
    const totalGratuitoCentimos = Math.round(acumuladorGratuito * 100);
    const totalIgvCentimos = Math.round(montoIgv * 100);

    const importeTotalComprobanteCentimos = totalGravadoCentimos + totalExoneradoCentimos + totalInafectoCentimos + totalExportacionCentimos + totalIgvCentimos + acumuladorIcbperEnCentimos;

    return {
        gravadas: (totalGravadoCentimos / 100).toFixed(2),
        exoneradas: (totalExoneradoCentimos / 100).toFixed(2),
        inafectas: (totalInafectoCentimos / 100).toFixed(2),
        gratuitas: (totalGratuitoCentimos / 100).toFixed(2),
        exportacion: (totalExportacionCentimos / 100).toFixed(2),
        igv: (totalIgvCentimos / 100).toFixed(2),
        icbper: (acumuladorIcbperEnCentimos / 100).toFixed(2),
        descuentoGlobal: descuentoGlobalNumerico.toFixed(2),
        total: (importeTotalComprobanteCentimos / 100).toFixed(2)
    };
}

